import React from 'react'
import styles from './whatsappChallan.module.scss'
import { couponBannerConfig } from './constants'

export const DynamicCouponBanner = ({ amount }: { amount?: number }) => {
  const message = couponBannerConfig.find(rule => rule.test(amount))?.get(amount || 0)

  return (
    <div className={styles.couponBanner}>
      <span className={styles.couponText}>{message}</span>
    </div>
  )
}
